import { useState } from 'react';
import { useSpace } from '../../../../hooks/useSpace';
import { usePermissions } from '../../../../hooks/usePermissions';
import useDisconnectDrive from '../../api/useDisconnectDrive';
import useGetDriveConfig from '../../api/useGetDriveConfig';
import { useStartGoogleOAuth } from '../../hooks/useStartGoogleOAuth';

export function useGoogleDriveCard() {
  const { currentSpace } = useSpace();
  const { isAdmin } = usePermissions();

  const configQuery = useGetDriveConfig();
  const disconnect = useDisconnectDrive();
  const { startOAuth } = useStartGoogleOAuth();

  const [isConfirmingDisconnect, setIsConfirmingDisconnect] = useState(false);

  function handleConnect() {
    if (!currentSpace) return;
    startOAuth(currentSpace.id);
  }

  function handleOpenDisconnect() {
    setIsConfirmingDisconnect(true);
  }

  function handleCloseDisconnect() {
    setIsConfirmingDisconnect(false);
  }

  async function handleConfirmDisconnect() {
    if (!currentSpace) return;
    await disconnect.mutateAsync({ spaceId: currentSpace.id });
    setIsConfirmingDisconnect(false);
  }

  return {
    isAdmin,
    config: configQuery.data ?? null,
    isLoading: configQuery.isLoading,
    isDisconnecting: disconnect.isPending,
    isConfirmingDisconnect,
    handleConnect,
    handleOpenDisconnect,
    handleCloseDisconnect,
    handleConfirmDisconnect,
  };
}
